"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSavedOffersContextValue = exports.useSavedOffersContextProvider = void 0;
const react_1 = __importDefault(require("react"));
const Api = __importStar(require("@src/api"));
const react_query_1 = require("react-query");
const queries_1 = require("@src/types/queries");
const react_intl_1 = require("react-intl");
const antd_1 = require("antd");
const useAppQuery_1 = require("@src/hooks/useAppQuery");
const account_context_1 = require("./account-context");
const SavedOffersContext = react_1.default.createContext({
    savedOffers: [],
    isFetching: false,
    isDeleting: false,
    isCreating: false,
    removeSavedOffer: () => { },
    createSavedOffer: () => { },
});
const useSavedOffersContextProvider = () => {
    const account = (0, account_context_1.useAccount)();
    const { data: savedOffers, isLoading: isFetching, refetch, } = (0, useAppQuery_1.useAppQuery)(queries_1.Queries.getSavedOffers, () => (account ? Api.SavedOffer.getSavedOffers() : []));
    const intl = (0, react_intl_1.useIntl)();
    const queryClient = (0, react_query_1.useQueryClient)();
    const { mutateAsync: createSavedOffer, isLoading: isCreating } = (0, react_query_1.useMutation)((offerId) => Api.SavedOffer.createSavedOffer(offerId), {
        onSuccess: isOfferAlreadySaved => {
            queryClient.invalidateQueries(queries_1.Queries.getSavedOffers);
            if (isOfferAlreadySaved) {
                antd_1.notification.warning({
                    message: intl.formatMessage({
                        id: 'general.warning',
                    }),
                    description: intl.formatMessage({
                        id: 'offers.saved_offers.offer_already_saved',
                    }),
                });
                return;
            }
            antd_1.notification.success({
                message: intl.formatMessage({
                    id: 'general.notification',
                }),
                description: intl.formatMessage({
                    id: 'offers.saved_offers.offer_saved',
                }),
            });
        },
        onError: err => {
            console.error(err);
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'general.error',
                }),
                description: intl.formatMessage({
                    id: 'general.something_went_wrong',
                }),
            });
        },
    });
    const { mutateAsync: removeSavedOffer, isLoading: isDeleting } = (0, react_query_1.useMutation)((offerId) => Api.SavedOffer.deleteSavedOffer(offerId), {
        onSuccess: () => {
            queryClient.invalidateQueries(queries_1.Queries.getSavedOffers);
            antd_1.notification.success({
                message: intl.formatMessage({
                    id: 'general.notification',
                }),
                description: intl.formatMessage({
                    id: 'offers.saved_offers.offer_removed',
                }),
            });
        },
        onError: err => {
            console.error(err);
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'general.error',
                }),
                description: intl.formatMessage({
                    id: 'general.something_went_wrong',
                }),
            });
        },
    });
    react_1.default.useEffect(() => {
        refetch();
    }, [account]);
    return {
        SavedOffersContextProvider: SavedOffersContext.Provider,
        value: {
            savedOffers: savedOffers || [],
            isFetching,
            removeSavedOffer,
            isDeleting,
            createSavedOffer,
            isCreating,
        },
    };
};
exports.useSavedOffersContextProvider = useSavedOffersContextProvider;
const useSavedOffersContextValue = () => {
    const context = react_1.default.useContext(SavedOffersContext);
    return context;
};
exports.useSavedOffersContextValue = useSavedOffersContextValue;
